import './Auth.scss';
import { useMutation } from '@tanstack/react-query';
import {
  App,
  Button,
  Card,
  Checkbox,
  Form,
  Image,
  Input,
  notification,
  Select,
  Switch,
} from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authLogin } from '../../network/auth';
import { motion } from 'framer-motion';
import {
  setCompanyName,
  setCurrentLang,
  setDataUser,
  setPractitioner,
  setToken,
  setUserName,
} from '../../services/store/slices/user';
import logo from '../../assets/logoNew.png';
import { setStoredToken } from '../../services/user-storage';
import key from '../../assets/key.png';
import user from '../../assets/User.png';
import banner from '../../assets/Frame 12.png';
import banner2 from '../../assets/Vector (1).png';
import { MdKeyboardArrowDown, MdLanguage } from 'react-icons/md';
const Login = ({ t }) => {
  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  const { currentLang } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const chanageLang = ({ key }) => {
    console.log(key);
    dispatch(setCurrentLang(key));
    document.getElementsByTagName('html')[0].setAttribute('lang', key);
  };
  const { mutate: onAuthLogin } = useMutation({
    mutationFn: (values) => authLogin(values),
    onSuccess: (res) => {
      // console.log('Login  res:', res);
      console.log('Login  cookies:', res?.data?.message);
      setLoading(false);
      if (!res?.data?.message?.sid)
        return message.error(
          " Please enter correct email and password. Don't forget to use correct case for email and password. "
        );
      // message.success(`welcome ${res?.data?.message?.username}`);
      notification.success({
        message: `Welcome ${res?.data?.message?.username}`,
        description: 'You have successfully logged in.',
      });
      dispatch(setToken(res?.data?.message?.sid));
      dispatch(setCompanyName(res?.data?.message?.company));
      setStoredToken(res?.data?.message);
      dispatch(setCurrentLang(res?.data?.message?.Language || 'en'));
      dispatch(setDataUser(res?.data?.message));
      // dispatch(setPractitioner(res?.data?.message?."Practitioner ID"));
      dispatch(
        setPractitioner(res?.data?.message?.['Practitioner ID'] || null)
      );
      dispatch(setUserName(res?.data?.message?.username));
      navigate('/');
    },
    onError: (error) => {
      setLoading(false);
      console.log('Login  error:', error);
      message.error(
        " Please enter correct email and password. Don't forget to use correct case for email and password. "
      );
    },
  });
  const onFinish = (values) => {
    setLoading(true);
    onAuthLogin({ usr: values.email, pwd: values.password });
  };
  return (
    <div className="flex w-full bg-[#FFFFFFA3]">
      {/* <div
        className="lg:w-1/2 w-full"
        style={{
          background:
            'linear-gradient(138.91deg, rgba(194, 207, 238, 0.64) 5.42%, rgba(218, 225, 240, 0.64) 72.94%)',
        }}
      >
        <div className="flex flex-col pt-[48px] px-[30px] sm:px-[117px] h-screen">
          <div className="header-login w-full flex justify-between pr-4">
            <img
              src={logo}
              alt="Logo"
              className="w-[170.35348510742188px] h-[48px]"
            />
            <Select
              defaultValue={currentLang}
              className="mb-4"
              // bordered={false}
              variant="borderless"
              suffixIcon={<MdKeyboardArrowDown color="#374151" size={16} />}
              prefix={<MdLanguage color="#374151" size={16} />}
              options={[
                { value: 'en', label: 'English' },
                { value: 'ar', label: 'Arabic' },
              ]}
              onChange={(value) => chanageLang({ key: value })}
            />
          </div>
          <div className="w-full h-screen flex flex-col items-center justify-center overflow-hidden relative">
            <Form
              name="login-form"
              className="w-full"
              layout="vertical"
              onFinish={onFinish}
              form={form}
            >
              <h2 className="text-[#1A1A1A] font-[700] text-[24px] mb-[32px] font-Tajawal">
                {t.Login}
              </h2>
              <Form.Item
                name="email"
                label={t.email}
                rules={[
                  { required: true, message: t.PleaseInputYourEmail },
                  {
                    type: 'email',
                    message: t.InvalidEmail,
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder={t.EnterYourEmail}
                  size="large"
                  prefix={
                    <img
                      src={user}
                      alt="User"
                      style={{
                        marginInlineEnd: '10px',
                      }}
                      // className="w-[24px] h-[24px]"
                    />
                  }
                />
              </Form.Item>
              <Form.Item
                name="password"
                label={t.password}
                rules={[{ required: true, message: t.PleaseInputYourPassword }]}
              >
                <Input.Password
                  placeholder={t.EnterYourPassword}
                  size="large"
                  prefix={
                    <img
                      src={key}
                      alt="Key"
                      style={{
                        marginInlineEnd: '10px',
                      }}
                      // className="w-[24px] h-[24px]"
                    />
                  }
                />
              </Form.Item>
              <div className="w-full flex items-center justify-between mb-[32px] mt-12">
                <Checkbox defaultChecked={true}>
                  <span className="text-[#272B2E] text-[16px] font-[500] font-Comfortaa">
                    {t.KeepMeConnected}
                  </span>
                </Checkbox>

                <span className="text-[#0344DC] text-[16px] font-[500] font-Comfortaa cursor-pointer hover:underline">
                  {t.RestorePassword}
                </span>
              </div>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  block
                  loading={loading}
                >
                  {t.Login}
                </Button>
              </Form.Item>
            </Form>
            <div className="absolute bottom-[48px] cursor-pointer w-full flex items-center gap-1 justify-center mt-8 text-[#939CA5] font-[500] text-[14px]">
              <span>{t.AllRightsReservedDHAYAELALDAN}</span>
              <span>{new Date().getFullYear()}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden lg:block lg:w-1/2 w-full overflow-hidden relative">
        <img src={banner} alt="Login" className="w-full h-screen" />
        <div className="">
          <img
            src={banner2}
            alt="Login"
            className={`absolute top-[71%] ${
              currentLang === 'ar' ? 'left-0.5' : 'right-0.5'
            } `}
            style={{
              transform: currentLang === 'ar' ? 'scaleX(1)' : 'scaleX(-1)',
            }}
          />
        </div>
      </div> */}
      <div className="flex w-full h-screen items-center justify-center">
        {/* <div
          className="lg:w-1/2 w-full"
          style={{
            background:
              'linear-gradient(138.91deg, rgba(194, 207, 238, 0.64) 5.42%, rgba(218, 225, 240, 0.64) 72.94%)',
          }}
        > */}
        {/* <div className="flex flex-col pt-[48px] px-[30px] sm:px-[117px] h-screen"> */}

        <Card
          className="login-card px-[20px] py-[38px]"
          style={{
            width: '560px',
            border: '3px solid #DEF2E5',
          }}
        >
          <div className="header-login w-full flex justify-between pr-4">
            <img
              src={logo}
              alt="Logo"
              className="w-[170.35348510742188px] h-[48px]"
            />
            <Select
              defaultValue={currentLang}
              className="mb-4"
              bordered={false}
              suffixIcon={<MdKeyboardArrowDown color="#374151" size={16} />}
              prefix={<MdLanguage color="#374151" size={16} />}
              options={[
                { value: 'en', label: 'English' },
                { value: 'ar', label: 'عربى' },
              ]}
              onChange={(value) => chanageLang({ key: value })}
            />
          </div>
          <div className="w-full h-[70vh] flex flex-col items-center justify-center overflow-hidden relative">
            <Form
              name="login-form"
              className="w-full"
              layout="vertical"
              onFinish={onFinish}
              form={form}
            >
              <h2 className="text-[#1A1A1A] font-[700] text-[24px] mb-[32px] font-Tajawal">
                {t.Login}
              </h2>
              <Form.Item
                name="email"
                label={t.email}
                rules={[
                  { required: true, message: t.PleaseInputYourEmail },
                  {
                    type: 'email',
                    message: t.InvalidEmail,
                  },
                ]}
              >
                <Input
                  type="text"
                  placeholder={t.EnterYourEmail}
                  size="large"
                  prefix={
                    <img
                      src={user}
                      alt="User"
                      style={{
                        marginInlineEnd: '10px',
                      }}
                      // className="w-[24px] h-[24px]"
                    />
                  }
                />
              </Form.Item>
              <Form.Item
                name="password"
                label={t.password}
                rules={[{ required: true, message: t.PleaseInputYourPassword }]}
              >
                <Input.Password
                  placeholder={t.EnterYourPassword}
                  size="large"
                  prefix={
                    <img
                      src={key}
                      alt="Key"
                      style={{
                        marginInlineEnd: '10px',
                      }}
                      // className="w-[24px] h-[24px]"
                    />
                  }
                />
              </Form.Item>
              <div className="w-full flex items-center justify-between mb-[32px] mt-12">
                <Checkbox defaultChecked={true}>
                  <span className="text-[#272B2E] text-[16px] font-[500] font-Comfortaa">
                    {t.KeepMeConnected}
                  </span>
                </Checkbox>

                <span className="text-[#0344DC] text-[16px] font-[500] font-Comfortaa cursor-pointer hover:underline">
                  {t.RestorePassword}
                </span>
              </div>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  block
                  loading={loading}
                >
                  {t.Login}
                </Button>
              </Form.Item>
              {/* <div className="flex items-center gap-3 justify-center mt-8">
                <p className="text-[#272B2E] text-[16px] font-[500] font-Comfortaa">
                  {t.DonHaveAnAccount}
                </p>
                <span className="text-[#0344DC] text-[16px] font-[500] font-Comfortaa cursor-pointer hover:underline">
                  {t.NewUserRegistration}
                </span>
              </div> */}
            </Form>
            <div className="absolute bottom-[48px] cursor-pointer w-full flex items-center gap-1 justify-center mt-8 text-[#939CA5] font-[500] text-[14px]">
              <span>{t.AllRightsReservedDHAYAELALDAN}</span>
              <span>{new Date().getFullYear()}</span>
            </div>
          </div>
        </Card>
        {/* </div> */}
        {/* </div> */}
        {/* <div className="hidden lg:flex lg:w-1/2 w-full overflow-hidden relative  items-center justify-center h-screen">
          <img
            src={banner}
            alt="Login"
            className="w-full h-full object-contain"
          />
        </div> */}
      </div>
    </div>
  );
};

export default Login;
// import './Auth.scss';
// import { useMutation } from '@tanstack/react-query';
// import {
//   App,
//   Button,
//   Card,
//   Checkbox,
//   Form,
//   Image,
//   Input,
//   notification,
//   Switch,
// } from 'antd';
// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { authLogin } from '../../network/auth';
// import { motion } from 'framer-motion';
// import {
//   setCompanyName,
//   setCurrentLang,
//   setDataUser,
//   setPractitioner,
//   setToken,
//   setUserName,
// } from '../../services/store/slices/user';
// // import logo from '../../assets/labeaute.png';
// import logo from '../../assets/logoNew.png';
// // import logo from '../../../public/icon-192x192.png';
// import { setStoredToken } from '../../services/user-storage';
// import imageAuth from '../../assets/auth-one-bg.jpg';
// import logolight from '../../assets/logo-light.png';
// import logodark from '../../assets/labeaute2.png';
// import { FaUserGroup } from 'react-icons/fa6';
// const Login = () => {
//   const [form] = Form.useForm();
//   const [checked, setChecked] = useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { message } = App.useApp();
//   const [loading, setLoading] = useState(false);
//   const { mutate: onAuthLogin } = useMutation({
//     mutationFn: (values) => authLogin(values),
//     onSuccess: (res) => {
//       // console.log('Login  res:', res);
//       console.log('Login  cookies:', res?.data?.message);
//       setLoading(false);
//       if (!res?.data?.message?.sid)
//         return message.error(
//           " Please enter correct email and password. Don't forget to use correct case for email and password. "
//         );
//       // message.success(`welcome ${res?.data?.message?.username}`);
//       notification.success({
//         message: `Welcome ${res?.data?.message?.username}`,
//         description: 'You have successfully logged in.',
//       });
//       dispatch(setToken(res?.data?.message?.sid));
//       dispatch(setCompanyName(res?.data?.message?.company));
//       setStoredToken(res?.data?.message);
//       dispatch(setCurrentLang(res?.data?.message?.Language || 'en'));
//       dispatch(setDataUser(res?.data?.message));
//       // dispatch(setPractitioner(res?.data?.message?."Practitioner ID"));
//       dispatch(
//         setPractitioner(res?.data?.message?.['Practitioner ID'] || null)
//       );
//       dispatch(setUserName(res?.data?.message?.username));
//       navigate('/');
//     },
//     onError: (error) => {
//       setLoading(false);
//       console.log('Login  error:', error);
//       message.error(
//         " Please enter correct email and password. Don't forget to use correct case for email and password. "
//       );
//     },
//   });
//   const onFormSubmit = (values) => {
//     setLoading(true);
//     onAuthLogin({ usr: values.email, pwd: values.password });
//   };
//   return (
//     <div className="">
//       {/* <div className="absolute top-0 left-0 w-full ">
//         <Switch
//           defaultChecked
//           checkedChildren="One"
//           unCheckedChildren="Two"
//           className="absolute top-4 right-4 z-10"
//           onChange={(checked) => {
//             setChecked(checked);
//           }}
//         />
//       </div> */}
//       {checked ? (
//         <div className="login bg-[#fbf7f4] pt-[3rem] relative ">
//           <div
//             className="absolute top-0 left-0 w-full h-[380px] "
//             style={{
//               backgroundImage: `url(${imageAuth})`,
//               backgroundSize: 'cover',
//               backgroundRepeat: 'no-repeat',
//               backgroundPosition: 'center',
//             }}
//           >
//             <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 text-center">
//               <div className="flex items-center justify-center gap-1 mb-0 md:mb-1">
//                 <h1 className="text-[#ffffff] text-[30px] md:text-[40px] font-[700] uppercase">
//                   Labeaute
//                 </h1>
//                 <Image
//                   src={logodark}
//                   alt="logo"
//                   preview={false}
//                   width={55}
//                   // height={60}
//                   // className="w-[50px] md:w-[50px]"
//                 />
//               </div>
//               <p className="text-[#ffffff80] text-[15px] font-[500]">
//                 Premium Admin & Dashboard Template
//               </p>
//             </div>
//             <div
//               className="absolute top-0 left-0 w-full h-full"
//               style={{
//                 background: 'linear-gradient(to right,#4a62fe,#687cfe)',
//                 opacity: '0.9',
//               }}
//             ></div>
//             <div className="absolute bottom-0 left-0 w-full">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 version="1.1"
//                 xmlnsXlink="http://www.w3.org/1999/xlink"
//                 viewBox="0 0 1440 120"
//                 className="w-full h-auto"
//               >
//                 <path
//                   d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"
//                   fill="#fbf7f4"
//                 ></path>
//               </svg>
//             </div>
//           </div>
//           <Card>
//             <Form
//               name="basic"
//               layout="vertical"
//               onFinish={onFormSubmit}
//               form={form}
//               className="login-form"
//             >
//               <div className="flex items-center justify-center gap-[6px] flex-col mt-1 mb-5">
//                 <h1 className="text-[#687cfe] text-[1.2rem] font-[600]">
//                   Welcome Back !
//                 </h1>
//                 <p className="text-[#878a99] text-[0.9rem] font-[600]">
//                   Sign in to continue to Velzon.
//                 </p>
//               </div>
//               <Form.Item
//                 label="Email"
//                 name="email"
//                 rules={[
//                   { required: true, message: 'Please input your email!' },
//                 ]}
//               >
//                 <Input type="email" placeholder="Email" />
//               </Form.Item>
//               <Form.Item
//                 label="Password"
//                 name="password"
//                 rules={[
//                   { required: true, message: 'Please input your password!' },
//                 ]}
//               >
//                 <Input.Password type="password" placeholder="Password" />
//               </Form.Item>
//               <Form.Item>
//                 <Checkbox>Remember me</Checkbox>
//               </Form.Item>
//               <Form.Item>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   loading={loading}
//                   block
//                   className="bg-[#ff7f5d] login-form-button"
//                 >
//                   Login
//                 </Button>
//               </Form.Item>
//             </Form>
//           </Card>
//         </div>
//       ) : (
//         <motion.div
//           className="login bg-[#fff] pt-[3rem] relative flex items-center flex-col lg:flex-row !justify-center lg:!justify-between gap-5 lg:gap-24 h-screen w-[95%] lg:w-[80%] m-auto"
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8, ease: 'easeOut' }}
//         >
//           <motion.div
//             className="flex items-center justify-center lg:w-1/2 w-full"
//             initial={{ opacity: 0, rotate: -10 }}
//             animate={{ opacity: 1, rotate: 0 }}
//             transition={{ duration: 1, ease: 'easeOut' }}
//           >
//             <motion.div
//               animate={{
//                 scale: [1, 1.05, 1],
//                 rotate: [0, 2, -2, 0],
//               }}
//               transition={{
//                 duration: 4,
//                 ease: 'easeInOut',
//                 repeat: Infinity,
//               }}
//             >
//               <Image
//                 src={logo}
//                 alt="logo"
//                 preview={false}
//                 className="w-[200px] lg:w-[400px]"
//               />
//             </motion.div>
//           </motion.div>
//           <motion.div
//             className="h-[50%] w-[2px] bg-[#dee2e6] hidden lg:block"
//             initial={{ opacity: 0, scaleY: 0 }}
//             animate={{ opacity: 1, scaleY: 1 }}
//             transition={{ duration: 1, ease: 'easeOut' }}
//           ></motion.div>

//           <motion.div
//             className="lg:w-1/2 w-full"
//             initial={{ opacity: 0, y: 20, scale: 0.95 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             transition={{ duration: 0.8, ease: 'easeOut' }}
//           >
//             <Card className="w-full lg:w-[450px] m-auto shadow-md">
//               <Form
//                 name="basic"
//                 layout="vertical"
//                 onFinish={onFormSubmit}
//                 form={form}
//                 className="login-form-two "
//               >
//                 <div className="flex items-center justify-center gap-[6px] flex-col mt-1 mb-5">
//                   {/* <FaUserGroup size={35} color="#687cfe" /> */}
//                   {/* <h1 className="text-[#687cfe] text-[1.2rem] font-[600]"> */}
//                   <FaUserGroup size={35} color="#0B9640" />
//                   <h1 className="text-[#0B9640] text-[1.2rem] font-[600]">
//                     Welcome Back !
//                   </h1>
//                   <p className="text-[#878a99] text-[0.9rem] font-[600]">
//                     Sign in to continue to Velzon.
//                   </p>
//                 </div>

//                 <Form.Item
//                   label="Email"
//                   name="email"
//                   rules={[
//                     { required: true, message: 'Please input your email!' },
//                   ]}
//                 >
//                   <Input type="email" placeholder="Email" />
//                 </Form.Item>

//                 <Form.Item
//                   label="Password"
//                   name="password"
//                   rules={[
//                     { required: true, message: 'Please input your password!' },
//                   ]}
//                 >
//                   <Input.Password type="password" placeholder="Password" />
//                 </Form.Item>

//                 <Form.Item>
//                   <Checkbox>Remember me</Checkbox>
//                 </Form.Item>

//                 <Form.Item>
//                   <Button
//                     type="primary"
//                     htmlType="submit"
//                     loading={loading}
//                     block
//                   >
//                     Login
//                   </Button>
//                 </Form.Item>
//               </Form>
//             </Card>
//           </motion.div>
//         </motion.div>
//       )}
//     </div>
//   );
// };

// export default Login;
